<template>
  <div class="Progress">
    <v-container fluid >
        <v-toolbar flat color="white">
            <v-toolbar-title>
                <h1 class="text-md-center"> Reporte Cliente ECA</h1>
            </v-toolbar-title>
            <v-btn color="green" dark  :disabled="dataVals === null">
              <download-csv
                :data="dataVals"
                :name="csvname + '.csv'"
                :labels="labels"
                :fields="fields"
              >
                <v-icon style="vertical-align: middle" left>cloud_download</v-icon>csv
              </download-csv>
            </v-btn>

        </v-toolbar>

        <v-layout row  justify-start >

            <v-flex xs12 sm4 md1 mb-2 pa-3>
               <h3 class="text-lg-center  m1">Filtro:</h3>
            </v-flex>

            <v-flex xs12 sm4 md2 mb-2>
                <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fechaInicial"
                        label="Desde:"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :clearable="true"
                    ></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaInicial" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex xs12 sm4 md2 mb-2>
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="fechaFinal"
                            label="Hasta:"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            :clearable="true"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaFinal" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </v-flex>

            <v-flex xs1>
                <v-btn round color="primary" dark v-on:click="getReportes">Buscar</v-btn>
            </v-flex>

        </v-layout>
        <data-table
            :headers="headers"
            :dataVals="dataVals"
            :searchActive="search"
            :key="tableKey"
        />
        <br>
        <v-layout row wrap>
         <h3> Referencias: </h3>

            <v-container fluid grid-list-sm>
                <v-layout row wrap>
                <v-flex  xs4>

                    <v-card color="teal lighten-2">
                        <v-card-title primary-title>
                            <h3>Sintoma 1</h3>
                        </v-card-title>
                        <v-card-text>
                            ¿Usted ha presentado en los últimos 14 días contacto con casos confirmados para COVID-19?
                        </v-card-text>

                    </v-card>

                </v-flex>
                <v-flex  xs4>

                    <v-card color="teal lighten-3">
                        <v-card-title primary-title>
                            <h3>Sintoma 2</h3>
                        </v-card-title>
                        <v-card-text>
                            Usted presenta actualmente alguno de los siguientes síntomas:
                            fiebre mayor a 37,5° , tos, secreción nasal, malestar general,
                            dolor de garganta, diarrea, vómito o dificultad respiratoria?
                        </v-card-text>

                    </v-card>

                </v-flex>
                <v-flex  xs4>

                    <v-card color="teal lighten-2">
                        <v-card-title primary-title>
                            <h3>Sintoma 3</h3>
                        </v-card-title>
                        <v-card-text >
                            Temperatura
                        </v-card-text>

                    </v-card>

                </v-flex>
                </v-layout>
            </v-container>
        </v-layout>

    </v-container >
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableBaseWithIcons'
import JsonCSV from 'vue-json-csv'

export default {

  name: 'Reporte Visitante',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },
  created () {
    this.getReportes()
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 10),

      fechaInicial: null,
      fechaFinal: null,

      menu1: false,
      modal: false,
      menu2: false,
      search: true,
      key: '1',

      backConf: {
        path: '/projects/covid/reporte_clientes/',
        // pathTimeLine: '/projects/covid/timeline/',
        // pathOption: '/projects/covid/options/',
        page: 1
      },

      // headers: ["Fecha", "Visitante", "Cédula", "Síntoma 1", "Síntoma 2", "Síntoma 3"],

      headers: [
        {
          text: 'Fecha',
          align: 'left',
          sortable: false,
          value: 'fecha'
        },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Sede', value: 'sede' },
        { text: 'Sintoma 1', value: 's1' },
        { text: 'Sintoma 2', value: 's2' },
        { text: 'Sintoma 3', value: 's3' }
      ],
      dataVals: [],
      csvname: 'ReporteCliente'

    }
  },
  methods: {

    getReportes () {
      // this.loading = true
      // this.datos = null

      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {}
      }

      if (this.fechaInicial) {
        request.params['fechaInicial'] = this.fechaInicial
      }
      if (this.fechaFinal) {
        request.params['fechaFinal'] = this.fechaFinal
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
        })
        .catch(err => console.error(err))
    }
  }
}
</script>
